import ActionTypes from '../constants/ActionTypes';

/* Actions */

export const createModelAttachment = (attachment) => ({
  type: ActionTypes.ATTACHMENT_CREATE,
  payload: {
    attachment,
  },
});

export const updateModelAttachment = (id, data) => ({
  type: ActionTypes.ATTACHMENT_UPDATE,
  payload: {
    id,
    data,
  },
});

export const deleteModelAttachment = (id) => ({
  type: ActionTypes.ATTACHMENT_DELETE,
  payload: {
    id,
  },
});

/* Events */

export const createModelAttachmentRequested = (localId, data) => ({
  type: ActionTypes.ATTACHMENT_CREATE_REQUESTED,
  payload: {
    localId,
    data,
  },
});

export const createModelAttachmentSucceeded = (localId, attachment) => ({
  type: ActionTypes.ATTACHMENT_CREATE_SUCCEEDED,
  payload: {
    localId,
    attachment,
  },
});

export const createModelAttachmentFailed = (localId, error) => ({
  type: ActionTypes.ATTACHMENT_CREATE_FAILED,
  payload: {
    localId,
    error,
  },
});

export const createModelAttachmentReceived = (attachment) => ({
  type: ActionTypes.ATTACHMENT_CREATE_RECEIVED,
  payload: {
    attachment,
  },
});

export const updateModelAttachmentRequested = (id, data) => ({
  type: ActionTypes.ATTACHMENT_UPDATE_REQUESTED,
  payload: {
    id,
    data,
  },
});

export const updateModelAttachmentSucceeded = (attachment) => ({
  type: ActionTypes.ATTACHMENT_UPDATE_SUCCEEDED,
  payload: {
    attachment,
  },
});

export const updateModelAttachmentFailed = (id, error) => ({
  type: ActionTypes.ATTACHMENT_UPDATE_FAILED,
  payload: {
    id,
    error,
  },
});

export const updateModelAttachmentReceived = (attachment) => ({
  type: ActionTypes.ATTACHMENT_UPDATE_RECEIVED,
  payload: {
    attachment,
  },
});

export const deleteModelAttachmentRequested = (id) => ({
  type: ActionTypes.ATTACHMENT_DELETE_REQUESTED,
  payload: {
    id,
  },
});

export const deleteModelAttachmentSucceeded = (attachment) => ({
  type: ActionTypes.ATTACHMENT_DELETE_SUCCEEDED,
  payload: {
    attachment,
  },
});

export const deleteModelAttachmentFailed = (id, error) => ({
  type: ActionTypes.ATTACHMENT_DELETE_FAILED,
  payload: {
    id,
    error,
  },
});

export const deleteModelAttachmentReceived = (attachment) => ({
  type: ActionTypes.ATTACHMENT_DELETE_RECEIVED,
  payload: {
    attachment,
  },
});
